import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const blogPreviews = [
  { slug: 'comment-faire-revenir-son-ex-rapidement', title: 'Comment Faire Revenir Son Ex Rapidement', excerpt: 'Guide complet avec les méthodes éprouvées du Grand Marabout.', category: 'Retour Affectif' },
  { slug: 'retour-affectif-temoignages-avis', title: 'Retour Affectif : Témoignages Vérifiés', excerpt: 'Découvrez les avis authentiques de clients satisfaits.', category: 'Témoignages' },
  { slug: 'marabout-serieux-france-reconnaitre-vrai', title: 'Reconnaître un Vrai Marabout Sérieux', excerpt: 'Les critères essentiels pour ne pas se faire arnaquer.', category: 'Guide' }
];

const HomeBlogSection = () => (
  <section className="py-10 bg-zinc-950">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
          Articles et Conseils du Grand Marabout
        </h2>
        <p className="text-base md:text-lg text-amber-100/70">
          Guides et témoignages pour vous aider à retrouver le bonheur
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {blogPreviews.map((article) => (
          <Link key={article.slug} to={`/blog/${article.slug}`}>
            <Card className="bg-gradient-to-br from-zinc-900 to-black border-amber-600/30 hover:border-amber-500/60 transition-all duration-300 transform hover:scale-105 group h-full">
              <CardContent className="p-5">
                <span className="text-xs px-2 py-1 bg-amber-500/10 border border-amber-500/30 rounded text-amber-300 mb-3 inline-block">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-bold text-amber-400 mb-2 group-hover:text-amber-300">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-amber-100/60">{article.excerpt}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>

      <div className="text-center mt-8">
        <Link to="/blog">
          <Button className="bg-amber-500/20 border border-amber-500/40 text-amber-300 hover:bg-amber-500/30 px-8 py-4 text-base">
            Voir tous les articles
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

export default HomeBlogSection;
